import qs from 'qs';
import type { CarrierCarrierInfo } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '../GatewayAxiosClient';
import type {
  BulkAssetLinkResults,
  BulkLinkAugmentationSetToContextsPayload,
  BulkLinkContractToContextsPayload,
  bulkLinkInjectionSitesToInjectionProfilesPayload,
} from './types';
export class UIOrchestrationService {
  async bulkLinkContractToContexts(payload: BulkLinkContractToContextsPayload): Promise<BulkAssetLinkResults> {
    return (await GatewayAxiosClient.post(`/ui-orchestration-proxy/api/v1/bulk/link-contract-to-contexts`, payload))
      .data;
  }
  async bulkLinkAugmentationSetToContexts(
    payload: BulkLinkAugmentationSetToContextsPayload,
  ): Promise<BulkAssetLinkResults> {
    return (
      await GatewayAxiosClient.post(`/ui-orchestration-proxy/api/v1/bulk/link-augmentation-set-to-contexts`, payload)
    ).data;
  }
  public async fetchZonesForCarrier(carriers?: string[], showInternational = true) {
    const res = await GatewayAxiosClient.get(`/ui-orchestration-proxy/api/v1/carrier/zones`, {
      paramsSerializer: (p) => {
        return qs.stringify(p, { arrayFormat: 'repeat' });
      },
      params: {
        showInternational,
        ...(carriers?.length ? { carriers } : {}),
      },
    });
    return res.data;
  }
  public async fetchPartnerCarrierSummaries(partnerId: string) {
    const res = await GatewayAxiosClient.get(`/ui-orchestration-proxy/api/v1/carrier/partner/${partnerId}`);
    return res.data;
  }
  public async fetchCarriers(): Promise<CarrierCarrierInfo[]> {
    const res = await GatewayAxiosClient.get('/ui-orchestration-proxy/api/v1/carrier/carrier-and-methods');
    // This field will be added the CI team at a future date.  For now we will patch in the values.
    return res.data;
  }

  public async fetchCarrier(carrierId: string): Promise<CarrierCarrierInfo> {
    const res = await GatewayAxiosClient.get(`/ui-orchestration-proxy/api/v1/carrier/carrier-and-methods/${carrierId}`);
    return res.data;
  }

  public async bulkLinkInjectionSitesToInjectionProfiles(
    payload: bulkLinkInjectionSitesToInjectionProfilesPayload,
  ): Promise<BulkAssetLinkResults> {
    return (
      await GatewayAxiosClient.post(`/ui-orchestration-proxy/api/v1/bulk/link-injection-sites-to-profiles`, payload)
    ).data;
  }
}
